<template>
  <div>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options">
      <!-- <span v-if="props.row.nom" slot="nom" slot-scope="props">{{ props.row.nom }}</span>
      <span v-if="props.row.prenom" slot="prenom" slot-scope="props">{{ props.row.prenom }}</span> -->

      <div v-if="props.row.nir" slot="nir" slot-scope="props" class="slot-number">
        <span>{{ formatNir(props.row.nir) }}</span>
      </div>

      <span v-if="props.row.nomdest" slot="nom" slot-scope="props">{{ props.row.nomdest }}</span>
      <span v-if="props.row.prenomdest" slot="prenom" slot-scope="props">{{ props.row.prenomdest }}</span>

      <div class="slot-center" slot="status" slot-scope="props">
        <span class="badge" :class="{'badge-success': props.row.status.isSent, 'badge-danger': !props.row.status.isSent}">
          {{ props.row.status.text }}
        </span>
      </div>
      <div slot="child_row" slot-scope="props">
        <table class="table b-table">
          <thead>
            <tr class="child_row">
              <th>Libelle Piéce</th>
              <th>Etablissement</th>
              <th>Bénéficiaire</th>
              <th>Bloquant</th>
              <th>Statut</th>
              <th>#</th>
            </tr>
          </thead>
          <tr v-for="(item, key) in props.row.details" :key="key">
            <td>{{ item.lib_cd_piece }}</td>
            <td>{{ item.rs_pm_site }}</td>
            <td>{{ item.prenom }} {{ item.nom }}</td>
            <td class="slot-center">
              <span class="badge" :class="{'badge-success': item.is_bloquant, 'badge-danger': !item.is_bloquant}">
                <i class="fa" :class="{'fa-check': item.is_bloquant, 'fa-close': !item.is_bloquant}" />
              </span>
            </td>
            <td class="slot-center">
              <span class="badge" :class="{'badge-success': item.is_sent, 'badge-danger': !item.is_uploaded, 'badge-warning' : item.is_uploaded }">
                <!-- <span v-if="item.is_uploaded">Chargé</span>
                <span v-if="item.is_sent">Envoyé</span>
                <span v-if="!item.is_uploaded">En attente</span> -->
                <span>{{ item.status }}</span>
              </span>
            </td>
            <td>
              <a href="#" v-if="item.is_uploaded" @click.prevent="download(item.id,item.id_pp_dest_reglement,item.rs_pm_site, item.lib_cd_piece)">
                Visualiser
              </a>
            </td>
          </tr>
        </table>
      </div>
      <div v-if="props.row.num_evt" slot="num_evt" slot-scope="props" class="slot-number">
        <span>{{ props.row.num_evt }}</span>
      </div>
    </v-server-table>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../utils/auth'
import { downloadFile } from '../utils/fileHelper'

export default {
  name: "JustificatifTable",
  props: ["tableEntry","statusTab"],
  data() {
    let self = this;
    return {
      url: '',
      columns: [
        "num_evt",
        "nir",
        "nom",
        "prenom",
        "status"
      ],
      options: {
        headings: {
          num_evt: "N° Dossier",
          nir: "N° Sécu. Soc.",
          nom: "Nom",
          prenom: "Prénom",
          status: "Statut"
        },
        sortable: ["nom"],
        filterable: false,
        perPage: 10,
        perPageValues: [10, 15, 20],
        texts: {
          filterPlaceholder: "N° Dossier"
        },
        orderBy: { column: "nom", ascending: true },
        requestFunction: function (data) {
            // self.url = '/espaceBeneficiaire/justificatifs/recherche'
            if (typeof self.tableEntry.benefId !== 'undefined' && self.tableEntry.benefId != '') {
              let benefId = self.tableEntry.benefId;
              self.url = '/espaceBeneficiaire/beneficiaires/justificatifs/' + benefId
              data["benefId"] = self.tableEntry.benefId;
            }
            else {
              self.url = '/espaceBeneficiaire/justificatifs/recherche'
              data["num_nsi"] = self.tableEntry.num_nsi;
              data["num_dossier"] = self.tableEntry.num_dossier;
              data["nir"] = self.tableEntry.nir;
              data["date_du"] = self.tableEntry.date_du;
              data["date_au"] = self.tableEntry.date_au;
              data["nom"] = self.tableEntry.nom;
              data["prenom"] = self.tableEntry.prenom;
              data["statut"] = self.tableEntry.statut;
              data["noSearch"] = self.$parent.noSearch
            }

            self.$store.commit("IS_LOADING", true);

            return axios.get(self.url, {
                params: data
            })
            .catch(function (e) {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
                showConfirmButton: false,
                timer: 5000
              });
            }.bind(this));
        }
      }
    }
  },
  computed: {
    items: {
      get() {
        return this.tableEntry
      }
    },
    status: {
      get() {
        return this.statusTab
      }
    }
  },
  methods: {
    onLoaded(){
      this.$store.commit("IS_LOADING", false);
    },
    formatNir(textNir) {
      if(textNir !== null  && textNir !== ''){

        let nirs = textNir.split(',');
        let displayNir = '';

        nirs.forEach(function (element){
          if(element.length > 13){
            if(displayNir === ''){
              displayNir = element.substring(0,13);
            }else{
              displayNir = displayNir + '\n' + element.substring(0,13);
            }
          }
        });
        return displayNir;
      }else{
        return textNir;
      }
    },
    download(justificatifId, nsi, etablissement, libelle) {
      let self = this
      let config = {
        justificatifId: justificatifId,
        nsi: nsi,
        etablissement: etablissement
      };
      this.$store.commit("IS_LOADING", true)
      this.$axios
        .post("/espaceBeneficiaire/justificatifs/getfileextension", config)
        .then(response => {
          let extension = response.data.extension
          this.$axios
            .post("/espaceBeneficiaire/justificatifs/telechargement", config, { responseType: "arraybuffer" })
            .then(response => {
              this.$store.commit("IS_LOADING", false)
              downloadFile(response, libelle, extension)
            })
            .catch(function(error) {
              self.$store.commit("IS_LOADING", false);
              let errorText = "Une erreur est survenue, si le problème persiste merci de faire un ticket au support"
              if (error.response && error.response.status === 404 && self !== undefined ) {
                errorText = "La pièce justificative demandée n'existe pas"
              }
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: errorText,
                showConfirmButton: false,
                timer: 5000
              })
            })
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false)
          let errorText ="Une erreur est survenue, si le problème persiste merci de faire un ticket au support"
          if (error.response && error.response.status === 404 && self !== undefined) {
            errorText = "La piéce justificative demandée n'existe pas"
          }
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: errorText,
            showConfirmButton: false,
            timer: 5000
          })
        })
    }
  }
}
</script>

<style scoped>
</style>
